// Module
var code = "<p>You may activate or deactivate your API-key by using the toggle. Your integrations with SurveyLegend require the API-key to be active to function. By deactivating the API-key, your integrations will stop functioning, since none would be able to access our API.</p> ";
// Exports
module.exports = code;